import React from 'react';
import './UserProfileCard.css';

// const serviceLabels = [
//   ['hasAttendanceService', 'Attendance'],
//   ['hasLeaveService', 'Leave'],
//   ['hasExpenseService', 'Expense'],
//   ['hasApprovalService', 'Approval'],
//   ['hasTimesheetService', 'Timesheet'],
// ];

const getInitials = (name = '') =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase() || 'CC';

const UserProfileCard = ({ user }) => {
  const [isExpanded, setIsExpanded] = React.useState(() => {
    if (typeof window === 'undefined') return true;
    return !window.matchMedia('(max-width: 520px)').matches;
  });
  const displayName = user?.userName || 'Crew User';
  const jobTitle = user?.jobTitle || user?.jobPosition || 'Team Member';
  const companyName = user?.companyName || 'Crew Core';
  // const enabledServices = serviceLabels.filter(([key]) => user?.[key]);

  return (
    <section className="user-profile" aria-label="User profile">
      <div className="user-profile__hero">
        <div className="user-profile__avatar-wrap">
          {user?.partnerImg ? (
            <img className="user-profile__avatar" src={user.partnerImg} alt={displayName} />
          ) : (
            <div className="user-profile__avatar user-profile__avatar--fallback">{getInitials(displayName)}</div>
          )}
          <span className="user-profile__status" aria-label="Active session" />
        </div>

        <div className="user-profile__identity">
          <p className="user-profile__eyebrow">{user?.isManager ? 'Manager Profile' : 'Employee Profile'}</p>
          <h3>{displayName}</h3>
          <p>{jobTitle}</p>
        </div>

        <button
          type="button"
          className={`user-profile__toggle${isExpanded ? ' user-profile__toggle--expanded' : ''}`}
          aria-expanded={isExpanded}
          aria-label={isExpanded ? 'Collapse profile details' : 'Expand profile details'}
          aria-controls="user-profile-details"
          onClick={() => setIsExpanded((current) => !current)}
        >
          <span aria-hidden="true">〱</span>
        </button>
      </div>

      <div
        id="user-profile-details"
        className={`user-profile__details${isExpanded ? '' : ' user-profile__details--collapsed'}`}
      >
        <div className="user-profile__detail">
          <span>Company</span>
          <strong>{companyName}</strong>
        </div>
        <div className="user-profile__detail">
          <span>Employee ID</span>
          <strong>{user?.employeeId || '-'}</strong>
        </div>
        <div className="user-profile__detail">
          <span>Database</span>
          <strong>{user?.db || '-'}</strong>
        </div>
      </div>

      {/* {enabledServices.length > 0 && (
        <div className="user-profile__services" aria-label="Enabled services">
          {enabledServices.map(([, label]) => (
            <span key={label}>{label}</span>
          ))}
        </div>
      )} */}
    </section>
  );
};

export const UserProfileCardSkeleton = () => (
  <section className="user-profile user-profile--skeleton" aria-label="Loading profile" aria-busy="true">
    <div className="user-profile__hero">
      <div className="user-profile-skeleton user-profile-skeleton--avatar" />
      <div className="user-profile__identity">
        <div className="user-profile-skeleton user-profile-skeleton--eyebrow" />
        <div className="user-profile-skeleton user-profile-skeleton--title" />
        <div className="user-profile-skeleton user-profile-skeleton--line" />
      </div>
    </div>
    <div className="user-profile__details">
      {[0, 1, 2].map((item) => (
        <div className="user-profile__detail" key={item}>
          <div className="user-profile-skeleton user-profile-skeleton--label" />
          <div className="user-profile-skeleton user-profile-skeleton--value" />
        </div>
      ))}
    </div>
  </section>
);

export default UserProfileCard;
